import { z } from 'zod';

import { zodCreatedListResponseSchema } from '../../validations';

export const zodCreateUsersViaCSVPayloadSchema = z.object({
  file: z.instanceof(File),
  formData: z.object({
    /** Minutes, an emptied field counts as no delay. */
    delayDuration: z.coerce.number().min(0).max(1440),
    sendEmail: z.boolean(),
  }),
});

export const zodCreateUsersViaCSVResponseSchema = zodCreatedListResponseSchema;
